function normalizeAllowlist(allowedOrigins) {
  if (!allowedOrigins || allowedOrigins === '*') {
    return '*';
  }

  if (allowedOrigins instanceof Set) {
    return allowedOrigins;
  }

  if (Array.isArray(allowedOrigins)) {
    return new Set(allowedOrigins);
  }

  return new Set([allowedOrigins]);
}

function isAllowedOrigin(origin, allowlist) {
  if (allowlist === '*') {
    return true;
  }

  if (!origin) {
    return false;
  }

  if (allowlist instanceof Set) {
    return allowlist.has(origin);
  }

  return false;
}

function safeParseMessage(event, allowlist) {
  if (!event || typeof event.data !== 'string') {
    return null;
  }

  const normalizedAllowlist = normalizeAllowlist(allowlist);
  if (!isAllowedOrigin(event.origin, normalizedAllowlist)) {
    return null;
  }

  let parsed = null;
  try {
    parsed = JSON.parse(event.data);
  } catch (error) {
    return null;
  }

  if (!parsed || typeof parsed.action !== 'string') {
    return null;
  }

  return parsed;
}

export { normalizeAllowlist, isAllowedOrigin, safeParseMessage };
